import { getPath } from '@/router/common'

const baseUrl = {
  title: '权限组',
  path: 'PermissionGroup'
}

export default [
  {
    path: getPath('OnlineData', baseUrl),
    name: 'OnlineData',
    component: () =>
      import(
        /* webpackChunkName: "OnlineData" */ '@/views/permissionGroup/onlineData/index.vue'
      ),
    meta: {
      title: '权限组'
    }
  },
  {
    path: getPath('permisindex_edit', baseUrl),
    name: 'permisindex_edit',
    component: () =>
      import(
        /* webpackChunkName: "permisindex_edit" */ '@/views/permissionGroup/permisindex_edit/index.vue'
      ),
    meta: {
      title: '权限组内容'
    }
  },
  {
    path: getPath('PermisIndex', baseUrl),
    name: 'PermissionGroup_PermisIndex',
    component: () =>
      import(
        /* webpackChunkName: "PermissionGroup_PermisIndex" */ '@/views/permissionGroup/permisIndex/index.vue'
      ),
    meta: {
      title: '权限元结构'
    }
  },
  {
    path: getPath('AllowsInspectOtherPleaseInquire', baseUrl),
    name: 'AllowsInspectOtherPleaseInquire',
    component: () =>
      import(
        /* webpackChunkName: "AllowsInspectOtherPleaseInquire" */ '@/views/permissionGroup/allowsInspectOtherPleaseInquire/index.vue'
      ),
    meta: {
      title: '请款单查看权限设置'
    }
  }
]
